import React, { useEffect, useState } from 'react'
import phoneIcon from '../imgs/contact/phone.svg'
import emailIcon from '../imgs/contact/mail.svg'
import wpIcon from '../imgs/contact/wp.svg'
import '../css/contact.css'
import { useContext } from 'react'
import { api } from '../api'
import { FaSpinner } from 'react-icons/fa6';
import { FaPaperPlane } from 'react-icons/fa';



const Contact = () => {
  const { t, language, handleSubmit, formMessage, isLoading, setFormMessage } = useContext(api)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [number, setNumber] = useState("")
  const [message, setMessage] = useState("")

  useEffect(() => {
    setFormMessage(null)
  }, [language])

  return (
    <main className="contactMain">
      {isLoading && <div div className="LoadingScreen"><FaSpinner className='wheel' fill='white' /></div>}
      <section className="contactSection" style={isLoading ? {cursor: "progress"} : {}}>
        <div className="forum" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
          <h1>{t("sendMsgH1")}</h1>
          <form>
            <input disabled={isLoading} value={name} onChange={(e) => {setName(e.target.value)}} type="text" placeholder={t("inputName")} />
            <input disabled={isLoading} value={email} onChange={(e) => {setEmail(e.target.value)}} type="email" placeholder={t("inputEmail")} />
            <input disabled={isLoading} value={number} onChange={(e) => {setNumber(e.target.value)}} type="phone" placeholder={t("inputPhone")} />
            <textarea disabled={isLoading} value={message} onChange={(e) => {setMessage(e.target.value)}} placeholder={t("inputMessage")} />
            <p>{t("getBack")}</p>
            <button disabled={isLoading} type='submit' onClick={async (e) => {
              e.preventDefault()
              await handleSubmit(name, email, number, message, setName, setEmail, setNumber, setMessage)
            }}><FaPaperPlane /></button>
            {formMessage && <div className="formMessage" style={{color: formMessage.color}}>
              <ul>
                {formMessage.message.map((item, index) => (
                  <li key={index}>{formMessage.message[index]}</li>
                  ))}
              </ul>
            </div>}
          </form>
        </div>
        <div className="ContactDividerLine"></div>
        <div className="contactInfo" >
          <h1 style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>{t("getInTouch")}</h1>
          <div className="contactContainer">
            <img className='contactImg' src={phoneIcon} alt="Phone" />
            <div className='contactText'>
              <a href='tel:+20224192049'>+20224192049</a>
              <a href='tel:+20222916039'>+20222916039</a>
              <a href='tel:+20224197480'>+20224197480</a>
            </div>
          </div>
          <div className="contactContainer">
            <img className='contactImg' src={wpIcon} alt="Whatsapp" />
            <div className='contactText'>
              <a href="https://wa.me/+201153272244">+201153272244</a>
              <a href="https://wa.me/+201111299502">+201111299502</a>
              </div>
          </div>
          <div className="contactContainer">
            <img className='contactImg' src={emailIcon} alt="email" />
            <div className='contactText'><a href="mailto:info@unitedgroupeg.com">info@unitedgroupeg.com</a></div>
          </div>
        </div>
      </section>
      
    </main>
  )
}

export default Contact